import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function initPostsListingTop(){
  const presentation_lines = document.querySelectorAll(".posts-listing-top .single-line-inner")
  
  if(presentation_lines && presentation_lines.length > 0){
    ScrollTrigger.create({
      trigger: '.posts-listing-top__presentation',
      start: "top center+=75",
      onEnter: () => {
        gsap.to(gsap.utils.toArray(presentation_lines), {y: 0, duration: 1.25, ease: "power3.out", stagger: 0.1})
      }
    })
  }
}

export default initPostsListingTop;